const link = () => {
  Array.from(document.querySelectorAll('a')).forEach(a => {
    a.setAttribute(
      'target',
      // eslint-disable-next-line no-restricted-globals
      location.hostname === a.hostname || !a.hostname.length
        ? '_self'
        : '_blank',
    );
  });
};

export default link;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/link.js